import { schema } from 'normalizr';

// Objects
const teamMemberSchema = new schema.Entity('teamMembers');
const teamConnectionSchema = new schema.Entity('teamConnections');
const bankAccountSchema = new schema.Entity('bankAccounts');
const addressSchema = new schema.Entity('addresses');
const userSchema = new schema.Entity('users');
const seasonSchema = new schema.Entity('seasons');

const clubSchema = new schema.Entity('clubs');
const organisationSchema = new schema.Entity('organisations');
const walkoverSchema = new schema.Entity('walkovers');
const competitionSchema = new schema.Entity('competitions');
const organisationSectionSchema = new schema.Entity('sections');
const teamDataImportSchema = new schema.Entity('teamDataImports');
const bulkImportSchema = new schema.Entity('bulkImports');
const creditCardSchema = new schema.Entity('creditCards');
const creditCardTokenSchema = new schema.Entity('creditCardTokens');
const purchaseSchema = new schema.Entity('purchases');
const tagSchema = new schema.Entity('tags');
const taggingSchema = new schema.Entity('taggings');
const groupImportSchema = new schema.Entity('groupImports');
const invitationSchema = new schema.Entity('invitations');
const enrolmentSchema = new schema.Entity('enrolments');
const mobileDeviceTokenSchema = new schema.Entity('mobileDeviceTokens');
const groupSchema = new schema.Entity('groups', {
  tags: new schema.Array(tagSchema),
  taggings: new schema.Array(taggingSchema),
  people: new schema.Array(new schema.Entity('people')),
});
const matchPaymentSchema = new schema.Entity('matchPayments');
const bulkMatchPaymentSchema = new schema.Entity('bulkMatchPayments');
const paymentEventSchema = new schema.Entity('paymentEvents');
const fixtureMatchSchema = new schema.Entity('fixtureMatches');
const reportSchema = new schema.Entity('reports');
const teamMemberSummarySchema = new schema.Entity('teamMemberSummaries');
const payoutSchema = new schema.Entity('payouts');
const payoutLineItemSchema = new schema.Entity('payoutLineItems');
const reminderSchema = new schema.Entity('reminders');
const paymentEventImportSchema = new schema.Entity('paymentEventImports');
const receiptSchema = new schema.Entity('receipts', {
  paymentEvents: paymentEventSchema,
  fixtureMatches: fixtureMatchSchema,
});

const peopleSchema = new schema.Entity('people', {
  groups: new schema.Array(groupSchema),
  tags: new schema.Array(tagSchema),
  taggings: new schema.Array(taggingSchema),
});
const paymentCollectionSchema = new schema.Entity('paymentCollections');
const teamPaymentCollectionSchema = new schema.Entity('teamPaymentCollections');
const paymentSchema = new schema.Entity('payments', {
  paymentCollections: new schema.Array(paymentCollectionSchema),
  groups: new schema.Array(groupSchema),
  tags: new schema.Array(tagSchema),
  taggings: new schema.Array(taggingSchema),
});
const teamPaymentRequestSchema = new schema.Entity('teamPaymentRequests', {
  teamPaymentCollections: new schema.Array(teamPaymentCollectionSchema),
});
const teamPaymentRequestMetricsSchema = new schema.Entity(
  'teamPaymentRequestMetrics',
  {
    teamPaymentCollections: new schema.Array(teamPaymentCollectionSchema),
  },
);
const paymentRecordSchema = new schema.Entity('paymentRecords', {
  paymentCollections: new schema.Array(paymentCollectionSchema),
  groups: new schema.Array(groupSchema),
  payments: new schema.Array(tagSchema),
  walkovers: new schema.Array(walkoverSchema),
  tags: new schema.Array(tagSchema),
});
const teamSchema = new schema.Entity('teams', {
  teamMembers: new schema.Array(teamMemberSchema),
  payments: new schema.Array(paymentSchema),
});
// Arrays of Objects
const teamListSchema = new schema.Array(teamSchema);
const clubListSchema = new schema.Array(clubSchema);
const addressListSchema = new schema.Array(addressSchema);
const teamMemberListSchema = new schema.Array(teamMemberSchema);
const teamConnectionListSchema = new schema.Array(teamConnectionSchema);
const creditCardListSchema = new schema.Array(creditCardSchema);
const tagListSchema = new schema.Array(tagSchema);
const taggingListSchema = new schema.Array(taggingSchema);
const teamDataImportListSchema = new schema.Array(teamDataImportSchema);
const groupListSchema = new schema.Array(groupSchema);
const peopleListSchema = new schema.Array(peopleSchema);
const paymentListSchema = new schema.Array(paymentSchema);
const bulkMatchPaymentListSchema = new schema.Array(bulkMatchPaymentSchema);
const matchPaymentListSchema = new schema.Array(matchPaymentSchema);
const paymentCollectionListSchema = new schema.Array(paymentCollectionSchema);
const teamPaymentCollectionListSchema = new schema.Array(
  teamPaymentCollectionSchema,
);
const teamPaymentRequestListSchema = new schema.Array(teamPaymentRequestSchema);
const organisationListSchema = new schema.Array(organisationSchema);
const bulkImportListSchema = new schema.Array(bulkImportSchema);
const organisationSectionListSchema = new schema.Array(
  organisationSectionSchema,
);
const walkoverListSchema = new schema.Array(walkoverSchema);
const purchaseListSchema = new schema.Array(purchaseSchema);
const paymentRecordListSchema = new schema.Array(paymentRecordSchema);
const groupImportListSchema = new schema.Array(groupImportSchema);
const paymentEventListSchema = new schema.Array(paymentEventSchema);
const fixtureMatchListSchema = new schema.Array(fixtureMatchSchema);
const paymentEventImportListSchema = new schema.Array(paymentEventImportSchema);
const competitionListSchema = new schema.Array(competitionSchema);
const reminderListSchema = new schema.Array(reminderSchema);
const reportListSchema = new schema.Array(reportSchema);
const payoutListSchema = new schema.Array(payoutSchema);
const payoutLineItemListSchema = new schema.Array(payoutLineItemSchema);
const seasonListSchema = new schema.Array(seasonSchema);
const teamMemberSummaryListSchema = new schema.Array(teamMemberSummarySchema);

export {
  addressListSchema,
  addressSchema,
  bankAccountSchema,
  bulkImportListSchema,
  bulkImportSchema,
  bulkMatchPaymentListSchema,
  bulkMatchPaymentSchema,
  teamDataImportSchema,
  teamDataImportListSchema,
  clubListSchema,
  clubSchema,
  competitionListSchema,
  competitionSchema,
  creditCardListSchema,
  creditCardSchema,
  creditCardTokenSchema,
  enrolmentSchema,
  fixtureMatchListSchema,
  fixtureMatchSchema,
  groupImportListSchema,
  groupImportSchema,
  groupListSchema,
  groupSchema,
  invitationSchema,
  matchPaymentListSchema,
  matchPaymentSchema,
  mobileDeviceTokenSchema,
  organisationListSchema,
  organisationSchema,
  organisationSectionListSchema,
  organisationSectionSchema,
  paymentCollectionListSchema,
  paymentCollectionSchema,
  paymentEventImportListSchema,
  paymentEventImportSchema,
  paymentEventListSchema,
  paymentEventSchema,
  paymentListSchema,
  paymentRecordListSchema,
  paymentRecordSchema,
  paymentSchema,
  payoutLineItemListSchema,
  payoutLineItemSchema,
  payoutListSchema,
  payoutSchema,
  peopleListSchema,
  peopleSchema,
  purchaseListSchema,
  purchaseSchema,
  receiptSchema,
  reminderListSchema,
  reminderSchema,
  reportListSchema,
  reportSchema,
  taggingListSchema,
  taggingSchema,
  tagListSchema,
  tagSchema,
  teamConnectionListSchema,
  teamConnectionSchema,
  teamListSchema,
  teamMemberListSchema,
  teamMemberSchema,
  teamPaymentCollectionListSchema,
  teamPaymentCollectionSchema,
  teamPaymentRequestListSchema,
  teamPaymentRequestMetricsSchema,
  teamPaymentRequestSchema,
  teamSchema,
  userSchema,
  walkoverListSchema,
  walkoverSchema,
  seasonListSchema,
  seasonSchema,
  teamMemberSummaryListSchema,
  teamMemberSummarySchema,
};
